var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.12695 17.0059H18.6934C20.3633 17.0059 21.2715 16.0781 21.2715 14.3789V3.56836C21.2715 1.85938 20.3633 0.941406 18.6348 0.941406H3.05859C1.39844 0.941406 0.490234 1.83984 0.490234 3.56836V14.3789C0.490234 16.0977 1.39844 17.0059 3.12695 17.0059ZM9.72852 9.87695L1.75977 2.07422C2.08203 1.79102 2.54102 1.64453 3.13672 1.64453H18.625C19.2402 1.64453 19.7285 1.82031 20.0605 2.14258L12.1504 9.87695C11.7402 10.2969 11.3008 10.4531 10.9395 10.4531C10.5879 10.4531 10.1289 10.2871 9.72852 9.87695ZM1.20312 14.3594V3.58789C1.20312 3.23633 1.25195 2.93359 1.34961 2.67969L7.92188 9.0957L1.38867 15.3652C1.26172 15.082 1.20312 14.75 1.20312 14.3594ZM20.5586 3.58789V14.3594C20.5586 14.7109 20.5098 15.0137 20.4023 15.2676L13.957 9.0957L20.4414 2.77734C20.5195 3.01172 20.5586 3.28516 20.5586 3.58789ZM3.13672 16.293C2.58984 16.293 2.15039 16.166 1.83789 15.9316L8.42969 9.58398L9.25977 10.4043C9.83594 10.9609 10.4219 11.166 10.9395 11.166C11.457 11.166 12.043 10.9609 12.6191 10.4043L13.4492 9.58398L19.9824 15.8633C19.6602 16.1465 19.2012 16.293 18.625 16.293H3.13672Z",
    fill: "#B399FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.73cf31cbd21e29b45923b8f72211144d.svg";
export { ForwardRef as ReactComponent };